import { SITE_CUSTOM_TAGS_GRID_NAME } from '../../constants';

import { actionLoadSiteCustomTagsRequest } from '../../actions/siteCustomTagsGrid';

import {
  ACTION_CREATE_CUSTOM_TAG__REQUEST,
  ACTION_CREATE_CUSTOM_TAG__FAIL,
  ACTION_CREATE_CUSTOM_TAG__SUCCESS,

  ACTION_DELETE_CUSTOM_TAG__FAIL,
  ACTION_DELETE_CUSTOM_TAG__SUCCESS,
  ACTION_DELETE_CUSTOM_TAG__REQUEST,
} from '../../actionTypes';

import { getGridSaga } from 'react-redux-app/lib/modules/grid/sagas';


export default getGridSaga(
  SITE_CUSTOM_TAGS_GRID_NAME,
  actionLoadSiteCustomTagsRequest,
  [ACTION_DELETE_CUSTOM_TAG__REQUEST, ACTION_CREATE_CUSTOM_TAG__REQUEST],
  [ACTION_DELETE_CUSTOM_TAG__FAIL, ACTION_CREATE_CUSTOM_TAG__FAIL],
  [ACTION_DELETE_CUSTOM_TAG__SUCCESS, ACTION_CREATE_CUSTOM_TAG__SUCCESS]
);
